import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

@Component({
    selector: 'lokos-button',
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ButtonComponent {
    @Input() changeIconTheme = false;
    @Input() count = 0;
    @Input() disabled = false;
    @Input() iconHeight = '1rem';
    @Input() iconPath = '';
    @Input() iconPosition: 'left' | 'right' = 'left';
    @Input() iconWidth = '1rem';
    @Input() isIcon = false;
    @Input() label = '';
    @Input() tooltip = '';
    @Input() type:
        | 'accent'
        | 'approve'
        | 'clear-all'
        | 'default'
        | 'icon'
        | 'outlined'
        | 'primary'
        | 'refresh'
        | 'reject'
        | 'table-btn' = 'default';

    @Output() afterClick = new EventEmitter();
}
